import React, { useContext, useEffect, useState } from 'react'
import { Form, Button, Input, message, Select, Descriptions, Tooltip, Tabs, Alert, Typography, Divider, Spin } from 'antd';
import {useFetch, useDiscord, useUnload} from '@utils'
import { appContext } from "./../../../AppContext";
import TextEditor from '../../text/TextEditor';
import CharacterSkills from './CharacterSkills';
import CharacterModalSlExtension from './CharacterModalSlExtension';
import Timeline from '../../timline/Timeline';
import TextEditorReadOnly from '../../text/TextEditorReadOnly';
import { IsStormvloed } from '@utils';
import { useMediaQuery } from 'react-responsive'

import CharacterComments from '../CharacterComments';
import TodoList from '../admin/TodoList';

const { Option } = Select;
const { TabPane } = Tabs;
const {Text} = Typography

function useFormLayout()
{
    return {
        hideRequiredMark: true,
        colon: false,
        layout:"inline"
    }
}

export default function Character({
    originalCharacter,
    characterTypes,
    characterStatusses,
    races,
    refresh
}) {
    const layout = useFormLayout();
    const [doFetch, FetchOptions] = useFetch();
    const [sendDiscordUpdate] = useDiscord();
    const [appState, AppDispatch] = useContext(appContext);
    const [newCharacter, setNewCharacter] = useState(originalCharacter)

    const [background, setBackground] = useState(originalCharacter?.background)
    const [slNotes, setSlNotes] = useState(originalCharacter?.slNotes)
    const [personalPossesions, setPersonalPossesions] = useState(originalCharacter?.personalPossesions)
    const [somethingChanged, setSomethingChanged] = useState(false);

    const [disableRaceChange, setDisableRaceChange] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false)
    const isStormvloed = IsStormvloed(appState.storyName)
    const isDead = originalCharacter.characterStatus?.name === 'Dead'
    const isBigScreen = !useMediaQuery({ maxWidth: 480 })

    const [form] = Form.useForm()

    useUnload(e => {
        if(somethingChanged) {
            e.preventDefault();
            e.returnValue = '';
        }
      });

    useEffect(() => {
        if(originalCharacter !== undefined) {
            setNewCharacter(originalCharacter)
            setBackground(originalCharacter.background)
            setSlNotes(originalCharacter.slNotes)
            setSomethingChanged(false);
        }
    }, [originalCharacter])

    useEffect(() => {
        setDisableRaceChange(false);

        if(newCharacter === undefined || newCharacter.skills === undefined) {
            return
        }
        newCharacter.skills.forEach(_ => {
            const foundReqRace = _.skill.requiredRaces?.find(req => req.race.id === newCharacter.race.id)
            if(foundReqRace !== undefined) {
                setDisableRaceChange(true);
            }
        })
    }, [newCharacter])

    useEffect(() => {
        form.setFieldsValue(originalCharacter)
        form.setFieldsValue({characterTypeId: originalCharacter?.characterType?.id})
        form.setFieldsValue({raceId: originalCharacter?.race?.id})
    },     //eslint-disable-next-line
    [form, originalCharacter])

    useEffect(() => {
        if(newCharacter === undefined) {
            return;
        }
        const algemeen = newCharacter.race.raceSkillPoints.find(_ => _.skillPointType.name === appState.skillPointTypeNames.algemeen)
        const strijd = newCharacter.race.raceSkillPoints.find(_ => _.skillPointType.name === appState.skillPointTypeNames.strijd)
        const ambacht = newCharacter.race.raceSkillPoints.find(_ => _.skillPointType.name === appState.skillPointTypeNames.ambacht)

        let algemeenPoints = algemeen?.amount ?? 0
        algemeenPoints = algemeenPoints + newCharacter.eventSkillPoints

        let strijdPoints = strijd?.amount ?? 0
        let ambachtPoints = ambacht?.amount ?? 0

        newCharacter.skills.forEach(_ => {
            switch(_.skill.skillPointType.name) {
                case appState.skillPointTypeNames.algemeen:
                    algemeenPoints = algemeenPoints - _.skill.pointCost
                    break;
                case appState.skillPointTypeNames.strijd:
                    if(strijdPoints - _.skill.pointCost >= 0) {
                        strijdPoints = strijdPoints - _.skill.pointCost
                    }
                    else {  
                        let pointsLeftToPay = _.skill.pointCost - strijdPoints
                        strijdPoints = 0;
                        algemeenPoints = algemeenPoints - pointsLeftToPay
                    }
                    break;
                case appState.skillPointTypeNames.ambacht:
                    if(ambachtPoints - _.skill.pointCost >= 0) {
                        ambachtPoints = ambachtPoints - _.skill.pointCost
                    }
                    else {  
                        let pointsLeftToPay = _.skill.pointCost - ambachtPoints
                        ambachtPoints = 0;
                        algemeenPoints = algemeenPoints - pointsLeftToPay
                    }
                    break;
                default:
                    break;
            }
        })

        setNewCharacter({
            ...newCharacter,
            skillPointsLeft: {
                    algemeen:algemeenPoints,
                    strijd:strijdPoints,
                    ambacht:ambachtPoints
                },
            skillPointsTotal: {
                algemeen: algemeen?.amount + newCharacter.eventSkillPoints,
                strijd: strijd?.amount ?? 0,
                ambacht: ambacht?.amount ?? 0
            }
        })

        
    }, // eslint-disable-next-line
    [newCharacter?.skills])

    const characterTypeOptions = characterTypes?.map(_ => {
        return (<Option 
          value={_.id} 
          key={_.id}
        >
          {_.name}
        </Option>)
      })

    const raceOptions = races?.map(_ => {
        return (<Option 
            value={_.id} 
            key={_.id}
        >
            {_.name}
        </Option>)
    })

    function getSkillPointsDescription() {
        return (
                <Descriptions.Item label="SkillPoints"> 
                    {isStormvloed  && "Algemeen: "}{newCharacter?.skillPointsLeft?.algemeen} / {newCharacter?.skillPointsTotal?.algemeen}
                    {isStormvloed && <>
                    <br />
                    Strijd: {newCharacter?.skillPointsLeft?.strijd} / {newCharacter?.skillPointsTotal?.strijd}
                    <br />
                    Ambacht: {newCharacter?.skillPointsLeft?.ambacht} / {newCharacter?.skillPointsTotal?.ambacht}
                    </>}
                </Descriptions.Item>
            )
    }

    function handleChangeTextEditorBackground(newContent) {
        setBackground(JSON.stringify(newContent))
        setSomethingChanged(true);
    }

    function handleChangeTextEditorPersonalPossessions(newContent) {
        setPersonalPossesions(JSON.stringify(newContent))
        setSomethingChanged(true);
    }
    
    function handleChangeTextEditorSlNotes(newContent) {
        setSlNotes(JSON.stringify(newContent))
        setSomethingChanged(true);
    }

    function onClickReview() {
        setIsUpdating(true)
        const url = `/api/character/setCharacterToReview/${newCharacter.id}`
       
        doFetch(url)
            .then((response) => onAddInventoryLoaded(response.isSuccess))

        function onAddInventoryLoaded(isSuccess) {
            if(isSuccess) {
                refresh()
                message.success('The character status has been updated');
                sendDiscordUpdate(`${appState.user?.name} request review for character with name ${newCharacter.name}. https://app.larptom.nl/${appState.appName}/character?id=${newCharacter.id}`)
                setIsUpdating(false)
                return;
            } 
            setIsUpdating(false)
            message.error('Could not set the character status');
        }
    }

    function onClickSlChangeStatus(newStatusName) {
        setIsUpdating(true)
        const newStatus = characterStatusses.find(_ => _.name === newStatusName)

        if(newStatus === undefined) {
            message.error(`Could not set the character status to ${newStatusName}`);
            return;
        }
       
        const url = `/api/character/setCharacterToStatus/${newCharacter.id}/${newStatus.id}`

        doFetch(url)
            .then((response) => onAddInventoryLoaded(response.isSuccess))

        function onAddInventoryLoaded(isSuccess) {
            if(isSuccess) {
                refresh()
                message.success(`The character status has been updated to ${newStatusName}`);
                setIsUpdating(false)
                return;
            } 

            setIsUpdating(false)
            message.error(`Could not set the character status to ${newStatusName}`);
        }
    }

    function setDeadAlert() {

        if(isDead === false) {
            return null;
        }
        return (
            <>
                <Alert
                    message="Your character is dead and can't be changed any more"
                    type="error"
                    showIcon
                />
                <br />
            </>
        )
    }

    function setChangeAlert() {

        if(somethingChanged === false) {
            return null;
        }

        return (
            <>
                <Alert
                    message="Don't forget to press on 'Update Character' to save the changes you made "
                    type="error"
                    showIcon
                />
                <br />
            </>
        )
    }

    function setSkillPointAlert() {

        if(newCharacter?.skillPointsLeft?.algemeen >= 0) {
            return null;
        }
        return (
            <>
                <Alert
                    message="Not enough skillpoints"
                    type="error"
                    showIcon
                />
                <br />
            </>
        )
    }

    function setStatusAlert() {

        switch(newCharacter?.characterStatus?.name ) {
            case "Rejected":
                return (<>
                    <Alert
                        message="The SL has rejected your character"
                        type="error"
                        showIcon
                    />
                    <br />
                </>)
            case "Accepted by SL":
                return (<>
                    <Alert
                        message="The SL has accepted your character"
                        type="success"
                        showIcon
                    />
                    <br />
                </>)
            case "Review for SL":
                return (<>
                    <Alert
                        message="The SL can now review your character"
                        type="info"
                        showIcon
                    />
                    <br />
                </>)
            case "Changed after Accepted":
                return (<>
                    <Alert
                        message="Changed"
                        description="You have changed your character after it has been accepted by the SL. Please ask for another verification"
                        type="warning"
                        showIcon
                    />
                    <br />
                </>)
            default:
                return null
        }
    }

    function addReviewButton() {

        if(newCharacter.characterStatus.name === "Review for SL" 
            || newCharacter.characterStatus.name === "Accepted by SL"){
            return null
        }

        return (
            newCharacter.characterType.name !== "Test" && <>
            <Text> | </Text>
            <Tooltip title="Update your character first if the button is disabled">
                <Button 
                    onClick={onClickReview}
                    disabled={somethingChanged}
                    loading={isUpdating}
                >
                    Ask SL for review
                </Button>
            </Tooltip>

        </>
        )
    }

    function addSlReviewButtons() {

        if(!appState.isSlOfStory) {
            return null;
        }

        if(newCharacter.characterStatus.name !== "Review for SL"){
            return null
        }

        return (
            <>
                <Text> | </Text>
                <Button 
                    onClick={() => onClickSlChangeStatus("Accepted by SL")}
                    disabled={somethingChanged}
                    loading={isUpdating}
                >
                    Accept
                </Button>
                <Text> | </Text>
                <Button 
                    onClick={() => onClickSlChangeStatus("Rejected")}
                    disabled={somethingChanged}
                    loading={isUpdating}
                >
                    Reject
                </Button>
            </>
        )
    }

    function onUpdate(values)
    {
        setIsUpdating(true)
        const url = appState.isSlOfStory ? `/api/character/AddOrUpdateCharacterSl` : `/api/character/AddOrUpdateCharacter`;
        const body = {
            id: originalCharacter.id,
            story: {
                id:appState.storyId
            },
            name:values.name,
            shortDescription:values.shortDescription,
            characterType: {
                id:values.characterTypeId
            },
            race: {
                id:values.raceId
            },
            eventSkillPoints:values.eventSkillPoints ?? newCharacter.eventSkillPoints,
            slNotes:slNotes,
            background:background,
            skills:newCharacter.skills,
            personalPossesions:personalPossesions
        }
        
        doFetch(url, FetchOptions.POST, body)
            .then((response) => onAddInventoryLoaded(response.isSuccess))

        function onAddInventoryLoaded(isSuccess) {
            if(isSuccess) {
                refresh()
                // setIsModalVisible(false);
                message.success('The character has been updated');
                setIsUpdating(false)
                setSomethingChanged(false);
                return;
            } 

            setIsUpdating(false)
            message.error('Could not update Character');
        }
    }

   
       
    if(newCharacter === undefined) {
        return null
    }

    // eslint-disable-next-line
    if(appState.storyId != originalCharacter.story.id) {
        AppDispatch({ type: "SETSTORYID", payload: {storyId:originalCharacter.story.id, storyName:originalCharacter.story.name} })
        return <Spin />
    //     return <Result
    //     status="403"
    //     title={`Please select ${originalCharacter.story.name}`}
    //     extra={<SelectStory />}
    //   />
    }

    return (
        <>
            {setDeadAlert()}
            {!isDead && setChangeAlert()}
            {!isDead && setSkillPointAlert()}
            {!isDead && setStatusAlert()}
            <div id="character-body" 
                style={{ display:"flex", 
                    flexDirection: isBigScreen ? 'row' : 'column',
                    justifyContent: 'space-between'}}
                >
                <div id="character-form" style={{ width: isBigScreen ? "55%" : "auto" }}>

                    <Form 
                        form={form}
                        {...layout}
                        name="basic"
                        layout="horizontal"
                        onFinish={onUpdate}>

                        <Descriptions bordered>
                            <Descriptions.Item label="Stats"> 
                                HP: {newCharacter.hp} 
                                {isStormvloed && <><br />
                                Strength: {newCharacter.strength}
                                </>}
                                <br />
                                Stamina: {newCharacter.stamina}
                                <br />
                                Mana: {newCharacter.mana}
                                {!isStormvloed && <><br />
                                Ritual Points: {newCharacter.rp}
                                </>}
                            </Descriptions.Item>
                            {getSkillPointsDescription()}
                            <Descriptions.Item label="Reeks" >
                                {newCharacter.story?.name}
                            </Descriptions.Item>
                            {appState.isSlOfStory && <Descriptions.Item label="Player" >
                                {newCharacter.larper?.name}
                            </Descriptions.Item>}
                        </Descriptions>

                        <br />
                        {!isDead && 
                            <Form.Item >
                                <Button
                                    type="primary" 
                                    htmlType="submit"
                                    disabled={!somethingChanged}
                                    loading={isUpdating}
                                >
                                    Update character
                                </Button>
                                
                                {addReviewButton()}
                                {addSlReviewButtons()}
                            </Form.Item>
                        }
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="Basic data" key="1">

                                <Form.Item
                                    label="Name"
                                    name="name"
                                >
                                    <Input name="name" onChange={() => setSomethingChanged(true)}/>
                                </Form.Item>

                                <Form.Item
                                    label="Short description"
                                    name="shortDescription"
                                >
                                    <Input name="shortDescription" onChange={() => setSomethingChanged(true)}/>
                                </Form.Item>

                                <Form.Item
                                    label="Type"
                                    name="characterTypeId"
                                    tooltip={
                                            <Tooltip>
                                                <span>Please make sure you only have 1 main character</span>
                                            </Tooltip>
                                        }
                                >
                                    <Select 
                                        name="characterTypeId" 
                                        onChange={() => setSomethingChanged(true)}
                                    >
                                        {characterTypeOptions}
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    label={isStormvloed ? "Race" : "World"}
                                    name="raceId"
                                    tooltip={
                                            <Tooltip>
                                                {
                                                    disableRaceChange 
                                                    ? <span>You have (a) skill(s) that requires this {isStormvloed ? "race" : "world"}, remove the skill to change the {isStormvloed ? "race" : "world"}</span> 
                                                    : <span>Only when you update the character after changing the {isStormvloed ? "race" : "world"}, will the stats and skillpoints be updated</span>
                                                }
                                            </Tooltip>
                                        }
                                >
                                    <Select 
                                        name="raceId" 
                                        disabled={disableRaceChange}
                                        onChange={() => setSomethingChanged(true)}
                                    >
                                        {raceOptions}
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                        label= 'Personal possessions/Marbles'
                                        name="personalPossesions"
                                        //style={appState.isSlOfStory && {"min-height":"200px"}}
                                        tooltip={
                                            <Tooltip>
                                                    <span>Only the SL can change this</span>
                                            </Tooltip>
                                        }
                                    >
                                    {appState.isSlOfStory ? 

                                            <TextEditor 
                                                content={newCharacter.personalPossesions}
                                                onChange={handleChangeTextEditorPersonalPossessions}
                                            />
                                        
                                        : <TextEditorReadOnly content={newCharacter.personalPossesions}/>
                                    }
                                </Form.Item>
                            </TabPane>
                            <TabPane tab="Skills" key="2">
                                {newCharacter !== undefined &&
                                    <CharacterSkills 
                                        allRaces={races}
                                        newCharacter={newCharacter}
                                        setNewCharacter={setNewCharacter}
                                        originalCharacter={originalCharacter}
                                        setSomethingChanged={setSomethingChanged}
                                        isStormvloed={isStormvloed}
                                    />
                                }

                            </TabPane>
                            <TabPane tab="Background" key="3">
                                <Form.Item
                                    style={{"min-height":"300px"}}
                                    label="Background"
                                    name="background"
                                >
                                    <TextEditor 
                                        content={newCharacter.background}
                                        onChange={handleChangeTextEditorBackground}
                                    />
                                </Form.Item>

                            </TabPane>
                            {appState.isSlOfStory && 
                                <TabPane tab="SL" key="4">
                                    <CharacterModalSlExtension 
                                        newCharacter={newCharacter}
                                        setSomethingChanged={setSomethingChanged}
                                        handleChangeTextEditorSlNotes={handleChangeTextEditorSlNotes}
                                        slNotes={slNotes}
                                        onClickSlChangeStatus={onClickSlChangeStatus}
                                    />
                                </TabPane>
                            }

                            {(appState.isSlOfStory || appState.user.isAdmin) && 
                                <TabPane tab="Timeline" key="5">
                                    <Timeline 
                                        changes={newCharacter?.timeline?.changes}
                                    />
                                </TabPane>
                            }


                        </Tabs>

                    </Form>
                    {!isBigScreen && <Divider />}
                </div>

                <div id="character-comments" style={{width:isBigScreen ? "40%" : "auto"}}>
                    <>
                        <TodoList 
                            data={originalCharacter.characterTodos}
                            refresh={refresh}
                            characterId={originalCharacter.id}
                            somethingChanged={somethingChanged}

                        />
                        <CharacterComments 
                            characterId={originalCharacter.id} 
                            characterName={originalCharacter.name}
                        />
                    </>
                </div>
            </div>
        </>
    )
}